import { getActiveAdvancedFilterCount } from "@/components/optimizer/filters/advanced-filter-count";
import { normalizeQueryState, type OptimizerQueryState } from "@/components/optimizer/query-state";
import { pricedChoices } from "@/lib/fantasy-props/rows";
import type { SniperFilters } from "./filters";

const SHEET_BASE = normalizeQueryState({ sportsbook: "draftkings" });

export const SNIPER_SHEET_PLATFORM = SHEET_BASE.platform;

export function sheetStateOf(filters: SniperFilters): OptimizerQueryState {
  return {
    ...SHEET_BASE,
    leagues: [...filters.leagues],
    gameDays: [...filters.days],
    startsWithin: filters.within,
    live: filters.live,
    marketScope: filters.marketScope,
    statTypes: [...filters.markets],
    matchups: [...filters.matchups],
    minEV: filters.minEv,
    minDataPoints: filters.minBooks,
    minLiquidity: filters.minLiquidity,
    requiredComparisonBooks: [...filters.requiredComparisonBooks],
    minOddsToHit: filters.minHit,
    maxOddsToHit: filters.maxHit,
    minOdds: filters.minOdds,
    maxOdds: filters.maxOdds,
    weights: filters.weights,
    preset: filters.preset,
    requiredBooks: [...filters.requiredBooks],
    hidePushProps: filters.hidePush,
    overUnder: filters.overUnder,
    boost: filters.boost,
  };
}

type Mutable<T> = { -readonly [K in keyof T]: T[K] };

export function filtersFromSheet(update: Partial<OptimizerQueryState>): Partial<SniperFilters> {
  const next: Partial<Mutable<SniperFilters>> = {};
  if (update.leagues !== undefined) next.leagues = update.leagues;
  if (update.gameDays !== undefined) next.days = update.gameDays;
  if (update.startsWithin !== undefined) next.within = update.startsWithin;
  if (update.live !== undefined) {
    next.live = update.live;
    next.breaks = false;
  }
  if (update.marketScope !== undefined) next.marketScope = update.marketScope;
  if (update.statTypes !== undefined) next.markets = update.statTypes;
  if (update.matchups !== undefined) next.matchups = update.matchups;
  if (update.minEV !== undefined) next.minEv = update.minEV;
  if (update.minDataPoints !== undefined) next.minBooks = update.minDataPoints;
  if (update.minLiquidity !== undefined) next.minLiquidity = update.minLiquidity;
  if (update.requiredComparisonBooks !== undefined) next.requiredComparisonBooks = update.requiredComparisonBooks;
  if (update.minOddsToHit !== undefined) next.minHit = update.minOddsToHit;
  if (update.maxOddsToHit !== undefined) next.maxHit = update.maxOddsToHit;
  if (update.minOdds !== undefined) next.minOdds = update.minOdds;
  if (update.maxOdds !== undefined) next.maxOdds = update.maxOdds;
  if (update.weights !== undefined) next.weights = update.weights;
  if (update.preset !== undefined) next.preset = update.preset;
  if (update.requiredBooks !== undefined) next.requiredBooks = update.requiredBooks;
  if (update.hidePushProps !== undefined) next.hidePush = update.hidePushProps;
  if (update.overUnder !== undefined) next.overUnder = update.overUnder;
  if (update.boost !== undefined) next.boost = update.boost;
  return next;
}

export function activeSniperFilterCount(filters: SniperFilters, diamond: boolean): number {
  return getActiveAdvancedFilterCount(pricedChoices(sheetStateOf(filters), diamond), true, true, true);
}
